/**
 * API Configuration - Environment-dependent URLs
 */

// Get the base URL for Firebase Functions based on environment
export const getFunctionsBaseUrl = (): string => {
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
  const isDev = process.env.NODE_ENV === 'development' && isLocalhost;
  
  if (isDev) {
    // Local emulator
    return 'http://localhost:5001/turnkeyosai/us-central1';
  } else {
    // Production Firebase Functions
    return 'https://us-central1-turnkeyosai.cloudfunctions.net';
  }
};

// Helper to build function URL
export const buildFunctionUrl = (functionName: string): string => {
  return `${getFunctionsBaseUrl()}/${functionName}`;
};